module.exports = __webpack_public_path__ + "static/img/xinLun.1e7e81a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LunBo/xinLun.jpg
// module id = xH8Z
// module chunks = 0